import { useCallback, useEffect, useState } from "react";

// Radikal-Konsolidierung 03.07.: 4 Tabs -> 2. "Ein Blick = Lage."
// AUFTRAG M B5 (04.07.): das Büro (Mails, Petra, Urlaub, Pipeline) zieht
// aus dem Geld-Tab in einen eigenen "Büro"-Tab — Geld bleibt reine Lage.
export type CockpitTab = "geld" | "buero" | "operativ" | "zahlen" | "team";

const TABS: readonly CockpitTab[] = ["geld", "buero", "team"];
const STORAGE_KEY = "cockpit.active-tab";
const DEFAULT_TAB: CockpitTab = "geld";

// Alte Hashes/localStorage-Werte (Bookmarks, Muscle-Memory) sanft umleiten.
const LEGACY_MAP: Record<string, CockpitTab> = {
  operativ: "buero", // Operativ-Inhalte wohnen jetzt im Büro
  zahlen: "geld",
};

function normalize(raw: string | null | undefined): CockpitTab | null {
  if (!raw) return null;
  const v = raw.toLowerCase();
  const mapped = LEGACY_MAP[v] ?? v;
  return TABS.includes(mapped as CockpitTab) ? (mapped as CockpitTab) : null;
}

function readHash(): CockpitTab | null {
  return normalize(window.location.hash.replace("#", ""));
}

function readStorage(): CockpitTab | null {
  try {
    return normalize(localStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}

export function useCockpitTab() {
  const [tab, setTabState] = useState<CockpitTab>(
    () => readHash() || readStorage() || DEFAULT_TAB,
  );

  const setTab = useCallback((next: CockpitTab) => {
    setTabState(next);
    window.location.hash = next;
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* quota */
    }
  }, []);

  useEffect(() => {
    const onHash = () => {
      const h = readHash();
      if (h) setTabState(h);
    };
    window.addEventListener("hashchange", onHash);
    if (!window.location.hash) {
      window.location.hash = tab;
    }
    return () => window.removeEventListener("hashchange", onHash);
  }, [tab]);

  return { tab, setTab, TABS } as const;
}
